// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Title_pageHeader__24amP","title":"Title_title__UDVgl","titleButton":"Title_titleButton__1j6t8"};